module.exports = __webpack_public_path__ + "img/background.a24b7fc3.jpeg";